import pizza1 from "../../images/pizzas-1.jpg";
import pizza2 from "../../images/pizzas-2.jpg";
import pizza3 from "../../images/pizzas-3.jpg";
import pizza4 from "../../images/pizzas-4.jpg";
import pizza5 from "../../images/pizzas-5.jpg";
import pizza6 from "../../images/pizzas-6.jpg";
import product1 from "../../images/product-1.jpg";
import product2 from "../../images/product-2.jpg";
import sweet1 from "../../images/sweet3.jpg";
import sweet2 from "../../images/sweet-2.jpg";
import sweet3 from "../../images/sweet-3.jpg";
import sweet4 from "../../images/sweet-4.jpg";
import sweet5 from "../../images/sweet-5.jpg";
import sweet6 from "../../images/sweet-6.jpg";

export const productData = [
  {
    img: pizza4,
    alt: "Pizza",
    name: "Numero Uno",
    desc:
      " Sausage, lots of pepperoni, red onions, peppers, mushrooms, Uno's own chunky vine-ripened tomato sauce, mozzarella and romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza5,
    alt: "Pizza",
    name: "Farmer's Market",
    desc:
      " Caramelized onions, fresh spinach, sun-dried and plum tomatoes, roasted eggplant, pesto, feta, mozzarella and imported pecorino romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza6,
    alt: "Pizza",
    name: "Veggie Extravaganza",
    desc:
      " House-roasted peppers, red onions, zucchini, and yellow squash with seasoned cherry tomatoes, mushrooms, and our three-cheese blend.  ",
    price: "$14.99",
    button: "Add to Cart"
  }
];
export const pizzaData = [
  {
    img: product1,
    alt: "Pizza",
    name: "Supreme Pizza",
    desc:
      "Caramelized onions, fresh spinach, sun-dried and plum tomatoes, roasted eggplant, pesto, feta, mozzarella and imported pecorino romano.",
    price: "$19.99",
    button: "Add to Cart"
  },
  {
    img: product2,
    alt: "Pizza",
    name: "Hawaiian Paradise",
    desc:
      " UNO’s three-cheese blend of freshly shredded mozzarella, aged cheddar, and imported pecorino romano with housemade pizza sauce.",
    price: "$16.99",
    button: "Add to Cart"
  },
  {
    img: pizza4,
    alt: "Pizza",
    name: "Numero Uno",
    desc:
      " Sausage, lots of pepperoni, red onions, peppers, mushrooms, Uno's own chunky vine-ripened tomato sauce, mozzarella and romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza5,
    alt: "Pizza",
    name: "Farmer's Market",
    desc:
      " Caramelized onions, fresh spinach, sun-dried and plum tomatoes, roasted eggplant, pesto, feta, mozzarella and imported pecorino romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza6,
    alt: "Pizza",
    name: "Veggie Extravaganza",
    desc:
      " House-roasted peppers, red onions, zucchini, and yellow squash with seasoned cherry tomatoes, mushrooms, and our three-cheese blend.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza1,
    alt: "Pizza",
    name: "Windy City Works",
    desc:
      "UNO’s three-cheese blend of freshly shredded mozzarella, aged cheddar, and imported pecorino romano with housemade pizza sauce. ",
    price: "$19.99",
    button: "Add to Cart"
  },
  {
    img: pizza2,
    alt: "Pizza",
    name: "Super Roni",
    desc:
      " House-roasted peppers, red onions, and yellow squash with seasoned cherry tomatoes, fresh baby spinach, mushrooms, and our three-cheese blend.  ",
    price: "$16.99",
    button: "Add to Cart"
  },
  {
    img: pizza3,
    alt: "Pizza",
    name: "BBQ Chicken",
    desc:
      " Chicken breast, red onions, mozzarella, aged cheddar and pecorino romano atop a layer of BBQ sauce. With a drizzle of even more BBQ sauce. ",
    price: "$14.99",
    button: "Add to Cart"
  }
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: "Donuts",
    name: "Doughlicious",
    desc:
      "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Caramel Wonder",
    desc:
      "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "$12.99",
    button: "Add to Cart"
  },
  {
    img: sweet1,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart"
  }
];

export const sweetData = [
  {
    img: sweet4,
    alt: "Ice Cream",
    name: "Uno Dish Sundae",
    desc:
      "Vanilla ice cream, chocolate sauce and whipped cream atop a giant chocolate chip cookie.",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet5,
    alt: "Ice Cream",
    name: "The All American",
    desc:
      "Granny Smith apples with sugar and cinnamon, baked with a brown sugar and rolled oat crust. ",
    price: "$12.99",
    button: "Add to Cart"
  },
  {
    img: sweet6,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet2,
    alt: "Donuts",
    name: "Doughlicious",
    desc:
      "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Caramel Wonder",
    desc:
      "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "$12.99",
    button: "Add to Cart"
  },
  {
    img: sweet1,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart"
  }
];

export const allproducts = [
  {
    img: sweet4,
    alt: "Ice Cream",
    name: "Uno Dish Sundae",
    desc:
      "Vanilla ice cream, chocolate sauce and whipped cream atop a giant chocolate chip cookie.",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet5,
    alt: "Ice Cream",
    name: "The All American",
    desc:
      "Granny Smith apples with sugar and cinnamon, baked with a brown sugar and rolled oat crust. ",
    price: "$12.99",
    button: "Add to Cart"
  },
  {
    img: sweet6,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet2,
    alt: "Donuts",
    name: "Doughlicious",
    desc:
      "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Caramel Wonder",
    desc:
      "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "$12.99",
    button: "Add to Cart"
  },
  {
    img: sweet1,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart"
  },
  {
    img: product1,
    alt: "Pizza",
    name: "Supreme Pizza",
    desc:
      "Caramelized onions, fresh spinach, sun-dried and plum tomatoes, roasted eggplant, pesto, feta, mozzarella and imported pecorino romano.",
    price: "$19.99",
    button: "Add to Cart"
  },
  {
    img: product2,
    alt: "Pizza",
    name: "Hawaiian Paradise",
    desc:
      " UNO’s three-cheese blend of freshly shredded mozzarella, aged cheddar, and imported pecorino romano with housemade pizza sauce.",
    price: "$16.99",
    button: "Add to Cart"
  },
  {
    img: pizza4,
    alt: "Pizza",
    name: "Numero Uno",
    desc:
      " Sausage, lots of pepperoni, red onions, peppers, mushrooms, Uno's own chunky vine-ripened tomato sauce, mozzarella and romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza5,
    alt: "Pizza",
    name: "Farmer's Market",
    desc:
      " Caramelized onions, fresh spinach, sun-dried and plum tomatoes, roasted eggplant, pesto, feta, mozzarella and imported pecorino romano.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza6,
    alt: "Pizza",
    name: "Veggie Extravaganza",
    desc:
      " House-roasted peppers, red onions, zucchini, and yellow squash with seasoned cherry tomatoes, mushrooms, and our three-cheese blend.  ",
    price: "$14.99",
    button: "Add to Cart"
  },
  {
    img: pizza1,
    alt: "Pizza",
    name: "Windy City Works",
    desc:
      "UNO’s three-cheese blend of freshly shredded mozzarella, aged cheddar, and imported pecorino romano with housemade pizza sauce. ",
    price: "$19.99",
    button: "Add to Cart"
  },
  {
    img: pizza2,
    alt: "Pizza",
    name: "Super Roni",
    desc:
      " House-roasted peppers, red onions, and yellow squash with seasoned cherry tomatoes, fresh baby spinach, mushrooms, and our three-cheese blend.  ",
    price: "$16.99",
    button: "Add to Cart"
  },
  {
    img: pizza3,
    alt: "Pizza",
    name: "BBQ Chicken",
    desc:
      " Chicken breast, red onions, mozzarella, aged cheddar and pecorino romano atop a layer of BBQ sauce. With a drizzle of even more BBQ sauce. ",
    price: "$14.99",
    button: "Add to Cart"
  }
];
